import React, {useState,useEffect} from "react";
import { User, Users, CreditCard, Phone, User2, User2Icon } from "lucide-react";
import TopBar from "../components/TopBar";
import './css/Profile.css';
import axios from './../axios';
const Profile = ({ setSideBar, setSettingDrawer }) => {
  // Placeholder data; replace with dynamic data from your backend
  
    const [student,setStudent] = useState(JSON.parse(localStorage.getItem('student')));
    const school = JSON.parse(localStorage.getItem('school'));
//    console.log('dsad'+JSON.parse(localStorage.getItem('student')));

useEffect(() => {
  const fetchProfile = async () => {
    try {
      const token = localStorage.getItem("student_token"); // or pass from props/context

      const response = await axios.get('student/profile', {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ clean header
        },
      });
 
      console.log(response.data);
      setStudent(response.data);
      
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };

  fetchProfile();
}, []);
 const safeValue = (value) => {
  return value && value.trim() !== '' ? value : '--';
};

const profileData = {
  class: safeValue(student.class),
  fatherName: safeValue(student.fname),
  motherName: safeValue(student.mname),
  aadharNumber: safeValue(student.adhar),
  mobileNumber: safeValue(student.mobile),
  inchargeNumber: safeValue(student.incharge_mobile),
  incharge: safeValue(student.incharge),
};


  return (
    <>
      <TopBar title="Profile" setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />
      <div className="profile-container">
        <div className="profile-header">
          <User2 size={20} className="header-icon" />
          <h2>Student Profile</h2>
        </div>
        <div className="profile-card">
          <div className="profile-field">
            <div className="field-icon">
              <User size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Class</span>
              <span className="field-value">{profileData.class}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <Users size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Father's Name</span>
              <span className="field-value">{profileData.fatherName}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <Users size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Mother's Name</span>
              <span className="field-value">{profileData.motherName}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <CreditCard size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Aadhar Card Number</span>
              <span className="field-value">{profileData.aadharNumber}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <Phone size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Mobile Number</span>
              <span className="field-value">{profileData.mobileNumber}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <User2Icon size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Incharge</span>
              <span className="field-value">{profileData.incharge}</span>
            </div>
          </div>
          <div className="profile-field">
            <div className="field-icon">
              <Phone size={18} />
            </div>
            <div className="field-content">
              <span className="field-label">Incharge Number</span>
              <span className="field-value">{profileData.inchargeNumber}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;